import type {
  Currency,
  DashboardPortfolioReport,
  HouseholdClientGroup,
  PortfolioObject,
  PortfolioReport,
} from '../types';

function toHouseholdClientGroup(
  group: { name?: string } | undefined,
): HouseholdClientGroup | undefined {
  if (!group?.name) return undefined;
  return { id: group.name, name: group.name };
}

function buildPortfolioObjectFromPin(
  pinned: DashboardPortfolioReport,
): PortfolioObject {
  const objectId = pinned.object?.id ?? pinned.id;

  if (pinned.modelPortfolioType === 'GOAL') {
    return {
      __typename: 'Goal',
      id: objectId,
      name: pinned.object?.name ?? 'Portfolio',
      householdClientGroup: toHouseholdClientGroup(
        pinned.object?.householdClientGroup,
      ),
      user: pinned.object?.user
        ? {
            id: objectId,
            firstName: pinned.object.user.firstName ?? '',
            lastName: pinned.object.user.lastName,
          }
        : undefined,
    };
  }

  return {
    __typename: 'SubAccount',
    id: objectId,
    account: {
      id: objectId,
      type: pinned.object?.account?.type ?? '',
      user: {
        id: objectId,
        firstName: pinned.object?.account?.user?.firstName ?? '',
        lastName: pinned.object?.account?.user?.lastName,
      },
    },
    goal: pinned.object?.goal
      ? {
          id: pinned.object.goal.name ?? objectId,
          name: pinned.object.goal.name ?? '',
          householdClientGroup: toHouseholdClientGroup(
            pinned.object.goal.householdClientGroup,
          ),
        }
      : undefined,
  };
}

export function buildPartialPortfolioReportFromPin(
  pinned: DashboardPortfolioReport,
): PortfolioReport {
  const baseCurrency: Currency = 'CAD';

  return {
    id: pinned.id,
    modelPortfolioType: pinned.modelPortfolioType,
    baseCurrency,
    object: buildPortfolioObjectFromPin(pinned),
    cashCents: pinned.cashCents ?? 0,
    pendingCashCents: 0,
    expectedCashCents: pinned.expectedCashCents ?? 0,
    cashAvailableForTradeCents: 0,
    expectedCashPercentage: 0,
    marketValueCents: pinned.marketValueCents ?? 0,
    pendingSubTradeRequests: pinned.pendingSubTradeRequests,
    unverifiedSubTradeRequests: pinned.unverifiedSubTradeRequests,
    pendingSubTradeRequestAllocations: 0,
    driftRebalanceRequired: pinned.driftRebalanceRequired,
    transferRebalanceRequired: pinned.transferRebalanceRequired,
    liquidateRebalanceRequired: pinned.liquidateRebalanceRequired,
    state: 'ACTIVE',
    updatedAt: '',
    holdings: [],
    subAccounts: [],
  };
}
